export default function LimitReachedModal({ onClose, onViewDetails }) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/40" onClick={onClose} />
            <div className="relative bg-white rounded-2xl shadow-xl max-w-md w-full p-6 space-y-4 text-center">
                <h3 className="text-lg font-semibold text-gray-800">
                    Bạn đã hết dung lượng sử dụng
                </h3>
                <p className="text-sm text-gray-500">
                    Xem chi tiết mức sử dụng và cách nhận thêm dung lượng.
                </p>
                <div className="flex gap-2">
                    <button
                        onClick={onClose}
                        className="flex-1 px-4 py-2.5 bg-brand-blue-100 hover:bg-brand-blue-200 text-gray-700 text-sm font-medium rounded-xl transition-colors"
                    >
                        Đã hiểu
                    </button>
                    <button
                        onClick={onViewDetails}
                        className="flex-1 px-4 py-2.5 bg-brand-blue-500 hover:bg-brand-blue-600 text-white text-sm font-medium rounded-xl transition-colors"
                    >
                        Xem chi tiết
                    </button>
                </div>
            </div>
        </div>
    );
}
